import { cva, cx } from "cva";
import Image from "next/image";
import { getValueOrDefault } from "~/lib/shared/getValueOrDefault";

export type SplitWithImageContainerProps = {
  children: React.ReactNode;
  imageAlt: string;
  imagePosition: "left" | "right";
  /** The image position to show on md+ breakpoints. If not set, it will use the value of imagePosition */
  mdImagePosition?: "left" | "right";
  imageUrl: string;
  verticalTextAlignment: "top" | "center";
};

const imageContainerStyles = cva("", {
  variants: {
    smImagePosition: {
      left: "order-0",
      right: "order-2",
    },
    mdImagePosition: {
      left: "md:order-0",
      right: "md:order-2",
    },
  },
});

const childrenContainerStyles = cva("order-1 flex flex-col", {
  variants: {
    verticalTextAlignment: {
      top: "",
      center: "justify-center",
    },
  },
});

export const SplitWithImageContainer: React.FC<
  SplitWithImageContainerProps
> = ({
  children,
  imageAlt,
  imagePosition,
  imageUrl,
  mdImagePosition,
  verticalTextAlignment,
}) => (
  <div className="grid w-full grid-cols-1 gap-l md:grid-cols-2">
    <div className={childrenContainerStyles({ verticalTextAlignment })}>
      {children}
    </div>
    <div
      className={cx(
        imageContainerStyles({
          smImagePosition: imagePosition,
          mdImagePosition: getValueOrDefault(mdImagePosition, imagePosition),
        }),
        "top-[72px] h-fit overflow-hidden md:sticky"
      )}
    >
      <Image
        alt={imageAlt}
        src={imageUrl}
        className="aspect-4/3 rounded-xl object-contain ring-1 ring-gray-400/10"
        width={800}
        height={600}
      />
    </div>
  </div>
);
